<div class="timeline-view-container">
  <div class="timeline-wrapper">
    <div class="timeline-line"></div>

    <!-- Individual Auction Items -->
    @for (auction of sortedAuctions; track auction) {
      <div class="auction-item">
        <div class="timeline-dot"></div>
        <div class="auction-card">
          <div class="auction-card-header">
            <!-- Interested Star Button -->
            <button
              class="interested-btn"
              [class.interested]="isInterested(auction.id)"
              [disabled]="!isLoggedIn"
              [title]="getInterestedTitle()"
              (click)="toggleInterested(auction.id, $event)"
              >
              <!-- Filled Star (when interested) -->
              @if (isInterested(auction.id)) {
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="M10 1.5L12.3175 7.19125L18.5 7.7875L14.025 11.7863L15.2075 17.8625L10 14.7675L4.7925 17.8625L5.975 11.7863L1.5 7.7875L7.6825 7.19125L10 1.5Z"
                    />
                  </svg>
                }
                <!-- Outline Star (when not interested) -->
                @if (!isInterested(auction.id)) {
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M10 1.5L12.3175 7.19125L18.5 7.7875L14.025 11.7863L15.2075 17.8625L10 14.7675L4.7925 17.8625L5.975 11.7863L1.5 7.7875L7.6825 7.19125L10 1.5Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      />
                    </svg>
                  }
                </button>
                <div class="auction-date">
                  <div class="date-day">{{ formatDay(auction.date) }}</div>
                  <div class="date-month">{{ formatShortMonth(auction.date) }}</div>
                </div>
                <div class="auction-info">
                  <h3 class="auction-title">
                    {{ getTranslatedField(auction.title) }}
                  </h3>
                  <div class="auction-meta">
                    <span class="auction-time">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          />
                          <path
                            d="M8 4V8L10.5 9.5"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            />
                          </svg>
                          {{ formatTime(auction.time) }}
                        </span>
                        <span class="auction-location">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                              d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              />
                              <path
                                d="M8 1.5C6.4087 1.5 4.88258 2.13214 3.75736 3.25736C2.63214 4.38258 2 5.9087 2 7.5C2 9.082 2.474 10.248 3.6 11.5L8 15.5L12.4 11.5C13.526 10.248 14 9.082 14 7.5C14 5.9087 13.3679 4.38258 12.2426 3.25736C11.1174 2.13214 9.5913 1.5 8 1.5Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                />
                              </svg>
                              {{ getTranslatedField(auction.location) }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="auction-card-body">
                        <p class="auction-description">
                          {{ getTranslatedField(auction.description) }}
                        </p>
                      </div>
                      <div class="auction-card-footer">
                        <span
                          class="auction-status"
                          [ngClass]="getStatusClass(auction.status)"
                          >
                          {{ getTranslatedStatus(auction.status) }}
                        </span>
                        <button
                          class="btn-view-auction"
                          [disabled]="!auction.auctionUrl"
                          (click)="openAuctionModal(auction)"
                          >
                          {{ "auctions_calendar.time_line.view_auction" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!-- Auction Modal -->
              @if (showModal && selectedAuction) {
                <app-auction-modal
                  [auction]="selectedAuction"
                  [translations]="translations"
                  [locale]="locale"
                  [appDir]="appDir"
                  (close)="closeModal()"
                ></app-auction-modal>
              }
            </div>
